(function () {
  'use strict';

  const root = document.querySelector('[data-ptc-cart-root]');
  if (!root) return;

  const moneyFormat = window.Shopify && Shopify.money_format ? Shopify.money_format : '${{amount}}';

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function setText(selector, value) {
    root.querySelectorAll(selector).forEach((el) => {
      el.textContent = value;
    });
  }

  function updateHeaderCartCount(count) {
    document.querySelectorAll('[data-ptm-cart-count], [data-cart-count], .ptm-cart-link b').forEach((el) => {
      el.textContent = count;
    });
  }

  function setCartTotals(cart) {
    const total = formatMoney(cart.total_price || 0);
    setText('[data-ptc-subtotal]', total);
    setText('[data-ptc-total]', total);
    setText('[data-ptc-sticky-total]', total);
    setText('[data-ptc-item-count]', cart.item_count + (cart.item_count === 1 ? ' artículo' : ' artículos'));
    updateHeaderCartCount(cart.item_count || 0);
  }

  function findLineItem(cart, key) {
    return (cart.items || []).find((item) => item.key === key);
  }

  async function changeLine(key, quantity, itemEl) {
    if (!key) return;

    itemEl && itemEl.classList.add('is-updating');

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: key, quantity: quantity })
      });

      if (!response.ok) throw new Error('No se pudo actualizar el carrito');

      const cart = await response.json();
      const updatedItem = findLineItem(cart, key);

      if (!updatedItem || quantity === 0) {
        if (itemEl) {
          itemEl.classList.add('is-removing');
          setTimeout(() => itemEl.remove(), 230);
        }
      } else if (itemEl) {
        const input = itemEl.querySelector('[data-ptc-qty-input]');
        const lineTotal = itemEl.querySelector('[data-ptc-line-total]');
        if (input) input.value = updatedItem.quantity;
        if (lineTotal) lineTotal.textContent = formatMoney(updatedItem.final_line_price);
      }

      setCartTotals(cart);

      if (cart.item_count === 0) {
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
      window.location.href = '/cart';
    } finally {
      itemEl && itemEl.classList.remove('is-updating');
    }
  }

  let inputTimer = null;

  root.addEventListener('click', (event) => {
    const minus = event.target.closest('[data-ptc-qty-minus]');
    const plus = event.target.closest('[data-ptc-qty-plus]');
    const remove = event.target.closest('[data-ptc-remove]');

    if (!minus && !plus && !remove) return;

    const itemEl = event.target.closest('[data-ptc-line-item]');
    if (!itemEl) return;

    const key = itemEl.getAttribute('data-ptc-line-key');
    const input = itemEl.querySelector('[data-ptc-qty-input]');
    const current = Math.max(0, Number(input && input.value ? input.value : 1));

    if (remove) {
      changeLine(key, 0, itemEl);
      return;
    }

    const nextQty = plus ? current + 1 : Math.max(0, current - 1);
    if (input) input.value = nextQty;
    changeLine(key, nextQty, itemEl);
  });

  root.addEventListener('input', (event) => {
    const input = event.target.closest('[data-ptc-qty-input]');
    if (!input) return;

    const itemEl = input.closest('[data-ptc-line-item]');
    if (!itemEl) return;

    const key = itemEl.getAttribute('data-ptc-line-key');
    const qty = Math.max(0, Number(input.value || 0));

    window.clearTimeout(inputTimer);
    inputTimer = window.setTimeout(() => {
      changeLine(key, qty, itemEl);
    }, 450);
  });

  const revealEls = root.querySelectorAll('.ptc-reveal');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });

    revealEls.forEach((el) => observer.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-visible'));
  }
})();
